"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SystemArrowLargeDownFill = { "icon": { "tag": "svg", "attrs": { "viewBox": "32 32 960 960", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M530.52 715.82l328.36-380.8c12.2-14.2 1.24-34.99-18.47-34.99H183.59c-19.7 0-30.72 20.78-18.47 34.99l328.36 380.8c9.39 10.88 27.6 10.88 37.04 0z" } }] }, "name": "system-arrow-large-down-fill", "theme": "outlined" };
exports.default = SystemArrowLargeDownFill;
